import React from "react";

function Icon(props) {
  return (
    <svg
      {...props}
      viewBox="0 0 84 93"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M42 88C50.2843 88 57 81.2843 57 73C57 64.7157 50.2843 58 42 58C33.7157 58 27 64.7157 27 73C27 81.2843 33.7157 88 42 88Z"
        stroke="white"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M42 76.3333C43.841 76.3333 45.3334 74.8409 45.3334 73C45.3334 71.159 43.841 69.6667 42 69.6667C40.1591 69.6667 38.6667 71.159 38.6667 73C38.6667 74.8409 40.1591 76.3333 42 76.3333Z"
        stroke="white"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M42 76.3333V88"
        stroke="white"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M38.6667 73L27.4167 69.6667"
        stroke="white"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M45.3333 73L56.5833 69.6667"
        stroke="white"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M70.4237 62.6391C68.8763 58.9737 66.6307 55.6443 63.812 52.8363C61.0019 50.0203 57.673 47.775 54.0093 46.2246C53.9765 46.2082 53.9437 46.2 53.9108 46.1836C59.0214 42.4922 62.3437 36.4793 62.3437 29.6953C62.3437 18.457 53.2382 9.35156 41.9999 9.35156C30.7616 9.35156 21.6561 18.457 21.6561 29.6953C21.6561 36.4793 24.9784 42.4922 30.089 46.1918C30.0562 46.2082 30.0233 46.2164 29.9905 46.2328C26.3155 47.7832 23.0179 50.0063 20.1878 52.8445C17.3717 55.6547 15.1265 58.9835 13.5761 62.6473C12.0529 66.2341 11.2315 70.0797 11.1561 73.9758C11.154 74.0633 11.1693 74.1504 11.2013 74.232C11.2333 74.3135 11.2813 74.3878 11.3425 74.4505C11.4036 74.5131 11.4767 74.563 11.5574 74.597C11.6381 74.631 11.7248 74.6485 11.8124 74.6484H16.7343C17.0952 74.6484 17.3823 74.3613 17.3905 74.0086C17.5546 67.6758 20.0976 61.7449 24.5929 57.2496C29.244 52.5984 35.421 50.0391 41.9999 50.0391C48.5788 50.0391 54.7558 52.5984 59.4069 57.2496C63.9022 61.7449 66.4452 67.6758 66.6093 74.0086C66.6175 74.3695 66.9046 74.6484 67.2655 74.6484H72.1874C72.275 74.6485 72.3617 74.631 72.4424 74.597C72.5231 74.563 72.5962 74.5131 72.6573 74.4505C72.7185 74.3878 72.7665 74.3135 72.7985 74.232C72.8305 74.1504 72.8458 74.0633 72.8437 73.9758C72.7616 70.0547 71.9495 66.2402 70.4237 62.6391ZM41.9999 43.8047C38.2347 43.8047 34.6909 42.3363 32.0249 39.6703C29.3589 37.0043 27.8905 33.4605 27.8905 29.6953C27.8905 25.9301 29.3589 22.3863 32.0249 19.7203C34.6909 17.0543 38.2347 15.5859 41.9999 15.5859C45.7651 15.5859 49.3089 17.0543 51.9749 19.7203C54.6409 22.3863 56.1093 25.9301 56.1093 29.6953C56.1093 33.4605 54.6409 37.0043 51.9749 39.6703C49.3089 42.3363 45.7651 43.8047 41.9999 43.8047Z"
        fill="white"
      />
    </svg>
  );
}

export default Icon;
